<template>
  <!-- Search Component -->
  <div>
    <!-- * Search Component -->
    <div class="appHeader background-TEAL text-light" style="z-index: 1000;">
      <div class="left" v-if="isLoggedIn">
        <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#sidebarPanel">
          <ion-icon name="menu-outline"></ion-icon>
        </a>
      </div>
      <div class="pageTitle">
        <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
        ایران ترابر رانندگان
        <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
      </div>
      <div class="right">
        
        <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#actionSheetShare" @click="backTell()">
          <ion-icon name="chatbubbles-outline"></ion-icon>
        </a>
      <!-- <a v-on:click="getLocation()" class="headerButton">
        <ion-icon name="location-outline"></ion-icon>
      </a> -->
        <!-- Modal Form -->

        <!-- * Modal Form -->
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "header",
  computed: {
    isLoggedIn() {
      return window.localStorage.getItem('idUser')
    }
  },
  setup() {
    const x = document.getElementById("demo");

    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
      }
    }

    function showPosition(position) {
      x.innerHTML = "Latitude: " + position.coords.latitude +
        "<br>Longitude: " + position.coords.longitude;
    }
    return { getLocation }
  },
  methods: {
    backTell(){
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }
  },
}
</script>
<style>
@import '../assets/css/custom.css';
</style>